import emailjs from "@emailjs/browser";
import { EMAIL_CONFIG } from "./EmailConfig";

export const enviarEmailConfirmacion = async (datos) => {
  try {
    const _parametros = {
      nombre_clienta: datos.nombre,
      email_clienta: datos.email,
      servicio: datos.servicio,
      fecha: datos.fecha,
      hora: datos.hora,
      precio: datos.precio,
    };

    await emailjs.send(
      EMAIL_CONFIG.serviceId,
      EMAIL_CONFIG.templateConfirmacion,
      _parametros,
      EMAIL_CONFIG.publicKey
    );

    return true;
  } catch (error) {
    console.error("Error al enviar email de confirmación:", error);
    return false;
  }
};